export default function UserSelectorTreeBuilderObserver(searchIndex, allActiveSet)
{
    this.searchIndex = searchIndex;
    this.allActiveSet = allActiveSet;
}

UserSelectorTreeBuilderObserver.prototype = {
    userNodeAdded: function(userNode)
    {
        var user = userNode.getValue();
        this.searchIndex.add(user.firstName, userNode.id);
        this.searchIndex.add(user.lastName, userNode.id);
        this.allActiveSet.add(userNode);
    },

    groupNodeAdded: function(groupNode)
    {
        this.searchIndex.add(groupNode.getValue().name, groupNode.id);
        this.allActiveSet.add(groupNode);
    },

    disabledUsersParentNodeAdded: function(parentNode)
    {
        this.allActiveSet.add(parentNode);
    }
};



// WEBPACK FOOTER //
// ./web/js/usersSelector/builder/UserSelectorTreeBuilderObserver.js